import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import BootstrapModal from "react-bootstrap/Modal";

const Modal: React.FC<any> = (
  props: React.PropsWithChildren<{ label: string }>
) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="dark" className="mx-2 my-2 bm-wrap" onClick={handleShow}>
        {props.label}
      </Button>

      <BootstrapModal
        className="bm-wrap"
        dialogClassName="bm-wrap"
        show={show}
        onHide={handleClose}
      >
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>{props.label}</BootstrapModal.Title>
        </BootstrapModal.Header>
        <BootstrapModal.Body>{props.children}</BootstrapModal.Body>
      </BootstrapModal>
    </>
  );
};

export default Modal;
